import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { PendingChangesGuard } from './core/pendingChanges.guard';
import { AuthGuard } from './core/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    data: { title: 'Login' },
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'forgotpassword',
    data: { title: 'Forgot Password' },
    loadComponent: () =>
      import('./pages/forgotpassword/forgotpassword.component').then(
        (m) => m.ForgotPasswordComponent
      ),
  },
  {
    path: 'resetpassword',
    data: { title: 'Reset Password' },
    loadComponent: () =>
      import('./pages/resetpassword/resetpassword.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'otp',
    data: { title: 'OTP Verification' },
    loadComponent: () =>
      import('./pages/otp/otp.component').then((m) => m.OtpComponent),
  },
  {
    path: 'terms',
    data: { title: 'Terms and Conditions' },
    loadComponent: () =>
      import('./pages/terms/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: 'otp-confirm',
    data: { title: 'OTP Confirmation' },
    loadComponent: () =>
      import('./pages/otp-confirm/otp-confirm.component').then(
        (m) => m.OtpConfirmComponent
      ),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      // { path: '', redirectTo: 'primary-order', pathMatch: 'full' }, // Optional default
      {
        path: 'dashboard',
        data: { title: 'Dashboard' },
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'invoice',
        data: { title: 'Goods Receipt Note' },
        loadComponent: () =>
          import('./pages/invoice/invoice.component').then(
            (m) => m.InvoiceComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'primary-order',
        data: { title: 'Primary Order' },
        loadComponent: () =>
          import('./pages/primary-order/primary-order.component').then(
            (m) => m.PrimaryOrderComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'sales-order',
        data: { title: 'Sales Orders' },
        loadComponent: () =>
          import('./pages/sales-order/sales-order-list/sales-order-list.component').then(
            (m) => m.SalesOrderListComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'sales-order/detail/:id',
        data: { title: 'Sales Order Detail' },
        loadComponent: () =>
          import('./pages/sales-order/sales-order-detail/sales-order-detail.component').then(
            (m) => m.SalesOrderDetailComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'sales-order/create',
        data: { title: 'Create Sales Order' },
        loadComponent: () =>
          import('./pages/sales-order/sales-order-create/sales-order-create.component').then(
            (m) => m.SalesOrderCreateComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      // Masters - Start
      {
        path: 'masters',
        data: { title: 'Masters' },
        loadComponent: () =>
          import('./pages/masters/masters-home/masters-home.component').then(
            (m) => m.MastersHomeComponent
          ),
      },
      {
        path: 'masters/employee',
        data: { title: 'Employee Master' },
        loadComponent: () =>
          import('./pages/masters/employee/employee-list/employee-list.component').then(
            (m) => m.EmployeeListComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'masters/employee/create',
        data: { title: 'Add Employee' },
        loadComponent: () =>
          import('./pages/masters/employee/employee-form/employee-form.component').then(
            (m) => m.EmployeeFormComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'masters/employee/edit/:id',
        data: { title: 'Edit Employee' },
        loadComponent: () =>
          import('./pages/masters/employee/employee-form/employee-form.component').then(
            (m) => m.EmployeeFormComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'masters/general',
        data: { title: 'General Masters' },
        loadComponent: () =>
          import('./pages/masters/general-masters/general-masters.component').then(
            (m) => m.GeneralMastersComponent
          ),
      },
      {
        path: 'masters/route',
        data: { title: 'Route Master' },
        loadComponent: () =>
          import('./pages/masters/route-master/route-master-list/route-master-list.component').then(
            (m) => m.RouteMasterListComponent
          ),
      },
      {
        path: 'masters/route/create',
        data: { title: 'Add Route' },
        loadComponent: () =>
          import('./pages/masters/route-master/route-master-form/route-master-form.component').then(
            (m) => m.RouteMasterFormComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'masters/route/edit/:id',
        data: { title: 'Edit Route' },
        loadComponent: () =>
          import('./pages/masters/route-master/route-master-form/route-master-form.component').then(
            (m) => m.RouteMasterFormComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'masters/dms-customer',
        data: { title: 'DMS Customer' },
        loadComponent: () =>
          import('./pages/masters/dms-customer/dms-customer-list/dms-customer-list.component').then(
            (m) => m.DmsCustomerListComponent
          ),
      },
      {
        path: 'masters/dms-customer/create',
        data: { title: 'Add DMS Customer' },
        loadComponent: () =>
          import('./pages/masters/dms-customer/dms-customer-form/dms-customer-form.component').then(
            (m) => m.DmsCustomerFormComponent
          ),
      },
      {
        path: 'masters/dms-customer/edit/:id',
        data: { title: 'Edit DMS Customer' },
        loadComponent: () =>
          import('./pages/masters/dms-customer/dms-customer-form/dms-customer-form.component').then(
            (m) => m.DmsCustomerFormComponent
          ),
      },
      {
        path: 'masters/new-distiz-customer',
        data: { title: 'New Distiz Customer' },
        loadComponent: () =>
          import('./pages/masters/new-distiz-customer/new-distiz-customer-list/new-distiz-customer-list.component').then(
            (m) => m.NewDistizCustomerListComponent
          ),
      },
      {
        path: 'masters/new-distiz-customer/create',
        data: { title: 'Add New Distiz Customer' },
        loadComponent: () =>
          import('./pages/masters/new-distiz-customer/new-distiz-customer-form/new-distiz-customer-form.component').then(
            (m) => m.NewDistizCustomerFormComponent
          ),
      },
      {
        path: 'masters/new-distiz-customer/edit/:id',
        data: { title: 'Edit New Distiz Customer' },
        loadComponent: () =>
          import('./pages/masters/new-distiz-customer/new-distiz-customer-form/new-distiz-customer-form.component').then(
            (m) => m.NewDistizCustomerFormComponent
          ),
      },
      {
        path: 'masters/sfc',
        data: { title: 'Standard Fare Chart' },
        loadComponent: () =>
          import('./pages/masters/sfc/sfc-list/sfc-list.component').then(
            (m) => m.SfcListComponent
          ),
      },
      {
        path: 'masters/sfc/create',
        data: { title: 'Add SFC' },
        loadComponent: () =>
          import('./pages/masters/sfc/sfc-form/sfc-form.component').then(
            (m) => m.SfcFormComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'masters/sfc/edit/:id',
        data: { title: 'Edit SFC' },
        loadComponent: () =>
          import('./pages/masters/sfc/sfc-form/sfc-form.component').then(
            (m) => m.SfcFormComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'storage-location',
        data: { title: 'Storage Location Master' },
        loadComponent: () =>
          import('./pages/masters/storage-location/storage-location-list/storage-location-list.component').then(
            (m) => m.StorageLocationListComponent
          ),
      },
      {
        path: 'storage-location/create',
        data: { title: 'Add Storage Location' },
        loadComponent: () =>
          import('./pages/masters/storage-location/storage-location-form/storage-location-form.component').then(
            (m) => m.StorageLocationFormComponent
          ),
      },
      {
        path: 'storage-location/edit/:id',
        data: { title: 'Edit Storage Location' },
        loadComponent: () =>
          import('./pages/masters/storage-location/storage-location-form/storage-location-form.component').then(
            (m) => m.StorageLocationFormComponent
          ),
      },
      {
        path: 'stock-transfer',
        data: { title: 'Stock Transfer' },
        loadComponent: () =>
          import('./pages/masters/stock-transfer/stock-transfer-list/stock-transfer-list.component').then(
            (m) => m.StockTransferListComponent
          ),
      },
      {
        path: 'stock-transfer/create',
        data: { title: 'New Stock Transfer' },
        loadComponent: () =>
          import('./pages/masters/stock-transfer/stock-transfer-form/stock-transfer-form.component').then(
            (m) => m.StockTransferFormComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'stock-transfer/view/:docNo',
        data: { title: 'Stock Transfer' },
        loadComponent: () =>
          import('./pages/masters/stock-transfer/stock-transfer-form/stock-transfer-form.component').then(
            (m) => m.StockTransferFormComponent
          ),
      },
      // Masters - End
      // Bulk Upload - Start
      {
        path: 'bulk-upload',
        data: { title: 'Bulk Upload' },
        loadComponent: () =>
          import('./pages/bulk-upload/bulk-upload-home/bulk-upload-home.component').then(
            (m) => m.BulkUploadHomeComponent
          ),
      },
      {
        path: 'bulk-upload/dms-customer',
        data: { title: 'DMS Customer Upload' },
        loadComponent: () =>
          import('./pages/bulk-upload/dms-customer-upload/dms-customer-upload.component').then(
            (m) => m.DmsCustomerUploadComponent
          ),
      },
      {
        path: 'bulk-upload/employee',
        data: { title: 'Employee Upload' },
        loadComponent: () =>
          import('./pages/bulk-upload/employee-upload/employee-upload.component').then(
            (m) => m.EmployeeUploadComponent
          ),
      },
      {
        path: 'bulk-upload/route',
        data: { title: 'Route Upload' },
        loadComponent: () =>
          import('./pages/bulk-upload/route-upload/route-upload.component').then(
            (m) => m.RouteUploadComponent
          ),
      },
      {
        path: 'bulk-upload/sfc',
        data: { title: 'SFC Upload' },
        loadComponent: () =>
          import('./pages/bulk-upload/sfc-upload/sfc-upload.component').then(
            (m) => m.SfcUploadComponent
          ),
      },
      // Bulk Upload - End
      // // Customer Onboarding - Start
      // {
      //   path: 'customer-onboarding',
      //   data: { title: 'Customer Onboarding' },
      //   loadComponent: () =>
      //     import('./pages/customer-onboarding/customer-onboarding-list/customer-onboarding-list.component').then(
      //       (m) => m.CustomerOnboardingListComponent
      //     ),
      //   canDeactivate: [PendingChangesGuard],
      // },
      // {
      //   path: 'customer-onboarding/create',
      //   data: { title: 'Create Customer Onboarding' },
      //   loadComponent: () =>
      //     import('./pages/customer-onboarding/customer-onboarding-create/customer-onboarding-create.component').then(
      //       (m) => m.CustomerOnboardingCreateComponent
      //     ),
      //   canDeactivate: [PendingChangesGuard],
      // },
      // {
      //   path: 'customer-onboarding/edit/:id',
      //   data: { title: 'Edit Customer Onboarding' },
      //   loadComponent: () =>
      //     import('./pages/customer-onboarding/customer-onboarding-create/customer-onboarding-create.component').then(
      //       (m) => m.CustomerOnboardingCreateComponent
      //     ),
      //   canDeactivate: [PendingChangesGuard],
      // },
      // // Customer Onboarding - End
      {
        path: 'sales-invoice',
        data: { title: 'Sales Invoices' },
        loadComponent: () =>
          import('./pages/sales-invoice/sales-invoice-list/sales-invoice-list.component').then(
            (m) => m.SalesInvoiceListComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'sales-invoice/create',
        data: { title: 'Create Sales Invoice' },
        loadComponent: () =>
          import('./pages/sales-invoice/sales-invoice-create/sales-invoice-create.component').then(
            (m) => m.SalesInvoiceCreateComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'sales-invoice/multi-convert',
        data: { title: 'Multi-Convert to Sales Invoice' },
        loadComponent: () =>
          import('./pages/sales-invoice/sales-invoice-multi-convert/sales-invoice-multi-convert.component').then(
            (m) => m.SalesInvoiceMultiConvertComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'sales-invoice/multi-convert/distribution',
        data: { title: 'Edit Distribution' },
        loadComponent: () =>
          import('./pages/sales-invoice/sales-invoice-multi-convert/distribution-edit/distribution-edit.component').then(
            (m) => m.DistributionEditComponent
          ),
      },
      {
        path: 'sales-invoice/detail/:id',
        data: { title: 'Sales Invoice Detail' },
        loadComponent: () =>
          import('./pages/sales-invoice/sales-invoice-detail/sales-invoice-detail.component').then(
            (m) => m.SalesInvoiceDetailComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'ledger',
        data: { title: 'Ledger Balance Report' },
        loadComponent: () =>
          import('./pages/ledger/ledger.component').then(
            (m) => m.LedgerComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'mtd',
        data: { title: 'MTD Report' },
        loadComponent: () =>
          import('./pages/mtd-report/mtd-report.component').then(
            (m) => m.MTDComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'ytd',
        data: { title: 'YTD Report' },
        loadComponent: () =>
          import('./pages/ytd-report/ytd-report.component').then(
            (m) => m.YTDComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'closing-stock',
        data: { title: 'Closing Stock' },
        loadComponent: () =>
          import('./pages/closing-stock/closing-stock.component').then(
            (m) => m.ClosingStockComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'monthly-forecast',
        data: { title: 'Monthly Forecast' },
        loadComponent: () =>
          import('./pages/monthly-forecast/monthly-forecast.component').then(
            (m) => m.MonthlyForecastComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'reports',
        data: { title: 'Reports' },
        loadComponent: () =>
          import('./pages/reports-home/reports-home.component').then(
            (m) => m.ReportsHomeComponent
          ),
      },
      {
        path: 'report/:slug',
        data: { title: 'Report', parentMenu: 'reports' },
        loadComponent: () =>
          import('./pages/report/report.component').then(
            (m) => m.ReportComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'loyalty-points',
        data: { title: 'Loyalty Points & Redemption' },
        loadComponent: () =>
          import('./pages/loyalty-redemption/loyalty-redemption.component').then(
            (m) => m.LoyaltyRedemptionComponent
          ),
        canDeactivate: [PendingChangesGuard],
      },
      {
        path: 'loyalty-redemption',
        redirectTo: 'loyalty-points',
        pathMatch: 'full',
      },
    ],
  },
  { path: '**', redirectTo: 'login' }, // ✅ Wildcard route for unknown paths
];